
export const getLocation = ({ street, city, state, country } = {}) =>
    [street, city, state, country].filter(Boolean).join(', ') || '';


export const getSelectedCarFeatures = async (carFeatures = [], settingsData = []) => {

    // Fallback: use carFeatures IDs with settingsData to look up feature names
    if (Array.isArray(carFeatures) && carFeatures?.length > 0 && Array.isArray(settingsData) && settingsData?.length > 0) {

        const featuresFromIds = settingsData?.filter((item => carFeatures.includes(item?.id))).map((item) => {
            return item?.itemName
        })

        if (featuresFromIds.length > 0) {
            return featuresFromIds.join(', ');
        }
    }
    // Return empty string if no valid data found
    return '';
};

export const getSelectedMakeAndModal = async (make, settingsData) => {
    return settingsData?.find(item => item.id == make)?.itemName
}


export const buildPreferences = ({
    formatMessage,
    location = '',
    carFeatures = '',
    carDetails = '',
    messages = {}
}) => {
    const makePref = (id, key, value, disabled = false) => ({
        id,
        label: `${formatMessage(messages?.[key])}:`,
        labelValue: `${value || '-'}`,
        name: key,
        value,
        disabled,
    });

    const allPrefs = [
        { id: 1, key: 'location', value: location, disabled: true },
        { id: 2, key: 'carFeatures', value: carFeatures },
        { id: 3, key: 'carDetails', value: carDetails },
    ];

    const filteredPrefs = allPrefs
        .filter(pref => pref.value && pref.value.trim() !== '')
        .map(pref => makePref(pref.id, pref.key, pref.value, pref.disabled));

    return filteredPrefs;
};

